<template>
  <section id="app" class="xsection">
    <router-view class=""/>
    <truckl-footer />
  </section>
</template>

<script>
import TrucklFooter from '@/components/Footer'
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters('user', ['isTokenValid'])
  },

  components: {
    TrucklFooter
  },

  methods: {
    ...mapActions('user', { getUserDetails: 'getDetails' }),
    ...mapActions('company', { getCompanyDetails: 'getDetails' })
  }
}
</script>

<style lang="scss">
@import '~buefy/dist/buefy.css';
@import '@/styles/index.scss';
</style>
